// extracted by mini-css-extract-plugin
export default {"chatBox":"chatBox-508b","placeholder":"placeholder-263b","button":"button-6aff","buttonContainer":"buttonContainer-5bdf"};